import { render, staticRenderFns } from "./subordinate.vue?vue&type=template&id=5478727a&scoped=true"
import script from "./subordinate.vue?vue&type=script&lang=js"
export * from "./subordinate.vue?vue&type=script&lang=js"
import style0 from "./subordinate.vue?vue&type=style&index=0&id=5478727a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5478727a",
  null
  
)

export default component.exports